import NamedContact from "../named-contact";
import BenefitPeriod from "./benefit-period";
import CareLocation from "./care-location";
import LookupValue from "./lookupValue";

export default class PatientChartBrief implements NamedContact {
  externalId: number;
  firstName: string;
  lastName: string;
  profileImagePath: string;
  gender: LookupValue;
  codeStatus: string;
  riskPriority: string;
  primaryDiagnosisCode: string;
  primaryDiagnosisDescription: string;
  secondaryDiagnosisCode: string;
  secondaryDiagnosisDescription: string;
  visitDiagnoses: string[];
  comorbiditiesDiagnosisDescription: string;
  levelOfCare: string;
  birthDate: Date;
  age: number;
  attendingPhysicianName: string;
  attendingPhysicianPhoneNumber: string;
  primaryCareGiverName: string;
  primaryCareGiverPhoneNumber: string;
  foodAllergies: string;
  drugAllergies: string;
  prefix: string;
  suffix: string;
  careLocation: CareLocation;
  benefitPeriod: BenefitPeriod;
  careType: string;
  serviceDate: ServiceDate;
}

interface ServiceDate {
  admittedDatetime: string;
  admittedDatetimeUtc: string;
  dischargedDatetime: string;
  dischargedDatetimeUtc: string;
  referredDateTime: string;
}

export interface ReferralSummaryResult {
  Patient: {
    Name: string;
    FullAddress: string;
    Gender: string;
    DOB: string;
  };
  ProvidersAndContacts: ProviderOrContact[];
  FacilitiesOrLocations: FacilityOrLocation[];
  Medical: MedicalInfo;
  PhysicalNotesSummary: string;
  LabResultsNotes: string;
}

interface ProviderOrContact {
  RelationOrRole: string;
  Name: string;
  Address: string;
  PhoneNumber: string;
}

interface FacilityOrLocation {
  Type: string;
  Name: string;
  Address: string;
  PhoneNumber: string;
}

interface MedicalInfo {
  Diagnoses: {
    PrimaryDiagnosis: string;
    SecondaryDiagnoses: string[];
    OtherComorbidities: string[];
  };
  Allergies: Allergy[];
  Medications: Medication[];
  Directives: string[];
}

interface Allergy {
  Allergy: string;
  Category: string;
  Reaction: string;
}

interface Medication {
  Medication: string;
  Dose: string;
  Frequency: string;
  route: string;
  Status: string;
}

export interface GetReferralSummaryResults {
  id: number;
  patientChartId: number;
  createdBy: string;
  updatedBy: string;
  createdDatetime: string;
  updatedDatetime: string;
  summaryText: object;
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/patient-chart-brief.ts